module.exports = __webpack_public_path__ + "img/pen.3a0233fe.svg";